<template>
    <v-list nav dense pa-0 ma-0 class="primary">
        <v-list-item v-for="(item, index) in computedTabs" :key="index" link @click="go(item.path, item.name)" active-class="darkgrey">
            <v-list-item-icon class="white--text">
                <v-icon class="navicons white--text">{{item.icon}}</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="white--text">{{ $t(`menu.${item.name}`) }}</v-list-item-title>
        </v-list-item>
    </v-list>

</template>

<script>
    import { mapGetters } from 'vuex'; // Map the Getters from the Vuex Store
    export default {
        name: "MenuList",
        data: () => ({
            tabs: [
                // USERS - VISITORS / CONTRACTORS / STAFF / DEVELOPERS
                { name: 'home', path: "/", icon: "icons8-home", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SU','SS','SM','SA','DA'] },
                { name: 'todos', path: "/todos", icon: "icons8-todo-list", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SU','SS','SM','SA','DA'] },
                { name: 'notices', path: "/notices", icon: "icons8-note", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SU','SS','SM','SA','DA'] },
                { name: 'projects', path: "/projects", icon: "icons8-project", userLevels: ['CU','CS','CM','CA','SM','SA','DA'] },
                { name: 'concerns', path: "/concerns", icon: "icons8-comments", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SM','SA','DA'] },
                { name: "firerollcall", path: "/firerollcall", icon: "icons8-fire", userLevels: ['SM','SA','DA'] },
                { name: "access", path: "/access", icon: "icons8-warranty", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SM','SA','DA'] },
                { name: "passes", path: "/passes", icon: "icons8-security-pass", userLevels: ['VU','VS','VM','VA','CU','CS','CM','CA','SM','SA','DA'] },
                // SUPERVISORS / MANAGERS - VISITORS / CONTRACTORS / STAFF / DEVELOPERS
                { name: 'sites', path: "/sites", icon: "icons8-apartment", userLevels: ['SM','SA','DA'] },
                { name: 'organisations', path: "/organisations", icon: "icons8-organization", userLevels: ['SM','SA','DA'] },
                { name: 'bulkUserQR', path: "/bulkUserQR", icon: "icons8-name-tag", userLevels: ['SM','SA','DA'] },
                { name: 'users', path: "/users", icon: "icons8-system-administrator-male", userLevels: ['SM','SA','DA', 'CU', 'CM', 'CA', 'CS'] },
                { name: 'slides', path: "/slides", icon: "icons8-presentation", userLevels: ['SM','SA','DA']},
                { name: 'questions', path: "/questions", icon: "icons8-test", userLevels: ['SM','SA','DA']},
                // { name: 'reports', path: "/reports", icon: "icons8-csv", userLevels: ['SM','SA','DA']},
                { name: "swappLog", path: "/swappLog", icon: "icons8-qr-code", userLevels: ['SM','SA','DA'] },
                // ADMIN - DEVELOPERS
                { name: 'settings', path: "/settings", icon: "icons8-settings", userLevels: ['DA'] },
                { name: 'guides', path: "/guides", icon: "icons8-question-mark", userLevels: ['DA'] },
                { name: 'files', path: "/files", icon: "icons8-documents", userLevels: ['DA'] },
                { name: 'simulator', path: "/simulator", icon: "icons8-advertisement-page", userLevels: ['DA'] },
                { name: 'notificationsadmin', path: "/notifications", icon: "icons8-todo-list", userLevels: ['DA'] },

            ],
            langPath: 'menuItems'
        }),
        computed: {
            ...mapGetters({
                GET_mobileNav: 'GET_mobileNav',
                GET_currentUser: 'GET_currentUser'
            }),
            computedTabs() {
                var t = this;
                var tabs = this.tabs;
                var newTabs = []
                tabs.forEach(function(tab) {
                    if (tab.userLevels.includes(t.GET_currentUser.userLevel)) {
                        newTabs.push (tab)
                    }
                })
                return newTabs
            }
        },
        methods: {
            updateBreadcrumbs(name, path) {
                var t = this;
                var breadcrumbs = [];
                var uperrcaseName = t.MIX_capitalizeText(name);
                breadcrumbs.push ({ name: uperrcaseName, path: path}) // Set the Main Path
                t.MIX_breadcrumbs(breadcrumbs);
            },
            go(path, name) {
                if (this.GET_currentUser.userStatus === 'APPROVED') {
                    this.$router.push(path).catch((err) => {
                        // console.log("Route error: " + err);
                    });
                    this.MIX_mobileNav(false);
                    this.updateBreadcrumbs(name, path);
                } else {
                    this.MIX_alert(0, "Your Account is not yet Approved", null, null)
                }
            },  
        }
    }
</script>

<style scoped>
.navicons {
  font-size: 24px !important;
  font-weight: bold !important;
}

.v-tab--active {
  background-color: var(--v-secondary-base) !important;
}

.tabsBackgroundImage{
  background: url("../../assets/navigation-background.jpg") !important;
  background-repeat: repeat;
  background-color: var(--v-primary-base) !important;
}
</style>
